import { render } from "./ImportFileView.vue?vue&type=template&id=b59812be"
import script from "./ImportFileView.vue?vue&type=script&lang=js"
export * from "./ImportFileView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/deniel/Documents/projects/translator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__